import { setMandatoryData } from "./var-helpers.js";
import { cloneObject, isObject } from "./object-helpers.js";
/**
 * Gets the cloned data of the model without the relations.
 *
 * @param model The model to clone
 * @param mandatoryData The data that has to exist on the cloned model
 * @param removeKeys The keys that must not exist on the cloned model
 */
export function cloneModelData(model, mandatoryData = {}, removeKeys = []) {
    if (!model) {
        return null;
    }
    let clonedModel = {};
    Object.keys(model).forEach(key => {
        const value = model[key];
        // Only add the value if it is not a relation or the model data to clone is explicitly defined
        if (!value || !model.model_name || !value.model_name) {
            if (Array.isArray(value)) {
                let containsModels = value.some(item => !!item.model_name);
                if (!model.model_name || !containsModels) {
                    clonedModel[key] = cloneObject(value);
                }
            }
            else {
                clonedModel[key] = isObject(value) ? { ...value } : value;
            }
        }
    });
    if (removeKeys) {
        removeKeys.forEach(key => {
            delete clonedModel[key];
        });
    }
    return setMandatoryData(clonedModel, mandatoryData);
}
export function getSportTypeLicenseNumberLangKey(sportType) {
    if (!sportType) {
        return 'default';
    }
    const sportTypeId = parseInt(isObject(sportType) ? sportType.id : sportType);
    return [2, 53, 55, 59].indexOf(sportTypeId) < 0 ? 'default' : 'triathlon';
}
//# sourceMappingURL=model-helpers.js.map